"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctRGB = correctRGB;
var consts_1 = require("./consts");
var clamp_1 = require("./clamp");
/** Corrects an RGB color to fall within the valid range.  */
function correctRGB(color) {
    return {
        r: (0, clamp_1.clamp)(color.r, consts_1.MAX_COLOR_RGB),
        g: (0, clamp_1.clamp)(color.g, consts_1.MAX_COLOR_RGB),
        b: (0, clamp_1.clamp)(color.b, consts_1.MAX_COLOR_RGB),
        a: typeof color.a === 'number' ? (0, clamp_1.clamp)(color.a, consts_1.MAX_COLOR_ALPHA) : color.a,
    };
}
//# sourceMappingURL=correctRGB.js.map